import React from 'react';
import {HStack, Text, VStack} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import Thumbnail from '@components/Thumbnail';
import type {ManagerArtist} from '@deezer/next/features/ClaimAccess/types';
import {ContentType} from '@deezer/next/services/types/contentType';

type ArtistNameCellProps = {
	artist: ManagerArtist;
} & TdProps;

const ArtistNameCell = ({artist, ...rest}: ArtistNameCellProps) => {
	const {id, picture, name, upc} = artist;

	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<HStack spacing="spacing.m">
				<Thumbnail
					id={String(id)}
					picture={picture}
					type={ContentType.Artist}
					rounded={true}
					width={'32px'}
					height={'32px'}
				/>
				<VStack alignItems="initial" spacing={0}>
					<Text
						noOfLines={1}
						fontWeight="semibold"
						wordBreak="break-all"
						data-testid="artist-name-cell-title"
					>
						{name}
					</Text>
					<Text
						noOfLines={1}
						wordBreak="break-all"
						data-testid="artist-name-cell-upc"
						display={{base: 'block', sm: 'none'}}
					>
						{upc}
					</Text>
				</VStack>
			</HStack>
		</Td>
	);
};

export default ArtistNameCell;
